export const DeclarationCotisationCacobath = {
    path: '/declaration_cotisation_cacobath',
    name: 'declaration_cotisation_cacobath',
    component: () => import('@/views/Impression/DeclarationCotisation/DeclarationCotisationCacobathPage.vue'),
    children: [
        {
            path: '/contribution_declarations_cacobath/add',
            name: 'contribution_declarations_cacobath.add',
            component: () => import('@/views/ContributionDeclaration/Form/ContributionDeclarationForm.vue'),
            props: {addAction: true, type: 'DECLARATION_COTISATION_CACOBATH'}
        },
        {
            path: '/contribution_declarations_cacobath/edit/:id',
            name: 'contribution_declarations_cacobath.edit',
            component: () => import('@/views/ContributionDeclaration/Form/ContributionDeclarationForm.vue'),
            props: {updateAction: true, type: 'DECLARATION_COTISATION_CACOBATH'}
        },
        {
            path: '/contribution_declarations_cacobath/delete/:id',
            name: 'contribution_declarations_cacobath.delete',
            component: () => import('@/views/ContributionDeclaration/Form/ContributionDeclarationForm.vue'),
            props: {deleteAction: true, type: 'DECLARATION_COTISATION_CACOBATH'}
        },
        {
            path: '/contribution_declarations_cacobath/view/:id',
            name: 'contribution_declarations_cacobath.view',
            component: () => import('@/views/ContributionDeclaration/Form/ContributionDeclarationForm.vue'),
            props: {viewAction: true, type: 'DECLARATION_COTISATION_CACOBATH'}
        },
    ]
}